module.exports = __webpack_public_path__ + "img/ico_copy_black.99d9c830.svg";